import {HTTP_UNPROCESSABLE_ENTITY} from "./http.error";
import ClientError from "./client.error";

export default class UnprocessableEntityError extends ClientError {
    /**
     * Constructor
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(message, response, previous) {
        super(HTTP_UNPROCESSABLE_ENTITY, message, response, previous);
        this.name = 'UnprocessableEntity';
    }
}